import { baseAPI } from '../index';

const getUserChats = async (uuid: string) => {
  const url = `/comment/${uuid}/all`;
  const { data } = await baseAPI.get(url, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization:
        typeof window !== 'undefined'
          ? `Bearer ${localStorage.getItem('token')}`
          : '',
    },
  });
  return data;
};

export default getUserChats;
